<template>
  <div>
    <add-new-chapter
      :is-add-new-chapter-sidebar-active.sync="isAddNewChapterSidebarActive"
      :subject-id="selectedSubjectId"
      :classId ="classId"
      :edit-chapter-data="moduleToEdit"
      :subjects="subjects"
      :topics ="topics"
      :modules="modules"
      @sendmoduledata="createModule"
      @editmoduledata="updateModule"
      @closeSidebar="closeSidebar"
    />
    <ShowModule
    v-if="showModuleModal"
    :module="selectedModule"
    @close="handleModalClose"
  />
    <!-- Main Content -->
    <b-card no-body>
      <div class="m-2">
        <b-row>
  <b-col cols="12">
    <div class="d-flex justify-content-between align-items-center mb-2">

      <!-- Left side -->
      <div>
        <b-button 
          :to="'/topics?class=' + classId + '&subject=' + selectedSubjectId"
          variant="secondary"
        >
          Go to Topics
        </b-button>
      </div>

      <!-- Right side -->
      <div class="d-flex align-items-center">
        <b-form-input 
          v-model="searchQuery" 
          class="mr-2" 
          placeholder="Search..." 
        />
        <b-button v-if="removeButtons == true"
          variant="primary" 
          @click="openAddChapterSidebar()"
        >
          <span class="text-nowrap">Add Module</span>
        </b-button>
      </div>

    </div>
  </b-col>

          <!-- <b-col cols="12" md="6" class="ml-auto">
            <div class="d-flex align-items-center">
              <b-button :to="'/topics?class=' + classId + '&subject=' + selectedSubjectId">Go to Topics</b-button>
              <b-form-input 
                v-model="searchQuery" 
                class="d-inline-block mr-1" 
                placeholder="Search..." 
              />
              <b-button 
                variant="primary" 
                @click="openAddChapterSidebar()"
              >
                <span class="text-nowrap">Add Module</span>
              </b-button>
              
            </div>
          </b-col> -->
        </b-row>
      </div>

      <b-card no-body class="mb-0">
        <div id="custom-table-container">
          <div class="table-wrapper">

          <b-table class="table table-hover table-striped">
            <b-thead>
              <b-tr>
                <b-th>#</b-th>
                <b-th>Order No</b-th>
                <b-th>Module Name</b-th>
                <b-th>Module Type</b-th>
                <b-th v-if="removeButtons == true">Require Subscription</b-th>
                <b-th v-if="removeButtons == true">Allow Gems</b-th>
                <b-th v-if="removeButtons == true">Android Access
              </b-th>
              <b-th v-if="removeButtons == true">Iphone Access
              </b-th>
              <b-th v-if="removeButtons == true">Ipad Access
              </b-th>
                <!-- <b-th>Public Access</b-th> -->
                <b-th v-if="removeButtons == true">Actions</b-th>
              </b-tr>
            </b-thead>

            <b-tbody is="draggable"
              v-model="modules"
              tag="tbody"
              handle=".drag-handle"
              @end="onDragEnd"
              class="scrollable-tbody"
            >
              <b-tr v-for="(module, index) in filteredModules" :key="module._id">
                    <b-td>
                      <feather-icon icon="MenuIcon" class="drag-handle" style="cursor: move;" />
                    </b-td>
                    <b-td>{{ module.module_no }}</b-td>
                    <b-td>{{ module.module_name }}</b-td>
                    <b-td style="width: 300px">
                    <span :style="getModuleTypeStyle(module.module_type)" class="module-type-badge">
                      {{ capitalize(module.module_type) }}

                    </span>
                    <!-- Evaluation -->
                    <div v-if="module.module_type === 'evaluation'" class="mt-1 ml-2">
                      <div><strong>Subjects:</strong>
                        <template v-if="module.subjects_data && module.subjects_data.length">
                          <span v-for="(subject, index) in module.subjects_data" :key="index">
                            {{ subject.subjectName }}<span v-if="index !== module.subjects_data.length - 1">, </span>
                          </span>
                        </template>
                        <template v-else>N/A</template>
                      </div>
                      <div><strong>Topics:</strong>
                        <template v-if="module.topics_data && module.topics_data.length">
                          <span v-for="(topic, index) in module.topics_data.slice(0, 2)" :key="index">
                            {{ topic.categoryName || 'N/A' }}<span v-if="index !== 1">, </span>
                          </span>
                           <br/>
                          <span v-if="module.topics_data.length > 2">
                            <a href="javascript:void(0)" class="ml-2 text-primary" @click="openModuleModal(module)">
                              (See More)
                            </a>
                          </span>
                        </template>

                        <template v-else-if="module.topicId && module.topicId.length">
                          <span v-for="(topic, index) in module.topicId.slice(0, 2)" :key="'topicId_' + index">
                            {{ topic.categoryName || 'N/A' }}<span v-if="index !== 1">, </span>
                          </span>

                          <span v-if="module.topicId.length > 2">
                            <a href="javascript:void(0)" class="ml-2 text-primary" @click="openModuleModal(module)">
                              (See More)
                            </a>
                          </span>
                        </template>

                        <template v-else>N/A</template>
                      </div>

                      <!-- <div><strong>Topics:</strong>
                        <template v-if="module.topics_data && module.topics_data.length">
                          <span v-for="(topic, index) in module.topics_data" :key="index">
                            {{ topic.categoryName || 'N/A' }}<span v-if="index !== module.topics_data.length - 1">, </span>
                            <a
                              href="javascript:void(0)"
                              class="ml-0 text-primary"
                              @click="openModuleModal(module)"
                            >
                            See More
                            </a>
                          </span>
                        </template>
                        <template v-else-if="module.topicId && module.topicId.length">
                          <span v-for="(topic, index) in module.topicId" :key="'topicId_' + index">
                            {{ topic.categoryName || 'N/A' }}<span v-if="index !== module.topicId.length - 1">, </span>
                          </span>
                        </template>
                        <template v-else>N/A</template>
                      </div> -->

                      <div><strong>Estimated Time:</strong> {{ module.estimated_time || 'N/A' }}</div>
                      <div><strong>Total Questions:</strong> {{ module.total_question || 'N/A' }}</div>
                    </div>
                    <!-- Comprehensive -->
                    <div v-if="module.module_type === 'comprehensive'" class="mt-1 ml-2">
                      <div><strong>Subjects:</strong>
                        <template v-if="module.subjects_data && module.subjects_data.length">
                          <span v-for="(subject, index) in module.subjects_data" :key="index">
                            {{ subject.subjectName }}<span v-if="index !== module.subjects_data.length - 1">, </span>
                          </span>
                        </template>
                        <template v-else>N/A</template>
                      </div>
                      <div><strong>Topics:</strong>
                        <template v-if="module.topics_data && module.topics_data.length">
                          <span v-for="(topic, index) in module.topics_data.slice(0, 2)" :key="index">
                            {{ topic.categoryName || 'N/A' }}<span v-if="index !== 1">, </span>
                          </span>
                           <br/>
                          <span v-if="module.topics_data.length > 2">
                            <a href="javascript:void(0)" class="ml-2 text-primary" @click="openModuleModal(module)">
                              (See More)
                            </a>
                          </span>
                        </template>

                        <template v-else-if="module.topicId && module.topicId.length">
                          <span v-for="(topic, index) in module.topicId.slice(0, 2)" :key="'topicId_' + index">
                            {{ topic.categoryName || 'N/A' }}<span v-if="index !== 1">, </span>
                          </span>

                          <span v-if="module.topicId.length > 2">
                            <a href="javascript:void(0)" class="ml-2 text-primary" @click="openModuleModal(module)">
                              (See More)
                            </a>
                          </span>
                        </template>

                        <template v-else>N/A</template>
                      </div>
                      <div><strong>Estimated Time:</strong> {{ module.estimated_time || 'N/A' }}</div>
                      <div><strong>Total Questions:</strong> {{ module.total_question || 'N/A' }}</div>
                    </div>
                    <!-- Practice Topic -->
                    <div v-else-if="module.module_type === 'topic'" class="mt-1 ml-2">
                      <div><strong>Topic:</strong>
                        <template v-if="module.topics_data && module.topics_data.length">
                          <span v-for="(topic, index) in module.topics_data" :key="index">
                            {{ topic.categoryName || 'N/A' }}<span v-if="index !== module.topics_data.length - 1">, </span>
                          </span>
                        </template>
                        <template v-else-if="module.topicId && module.topicId.length">
                          <span v-for="(topic, index) in module.topicId" :key="'topicId_' + index">
                            {{ topic.categoryName || 'N/A' }}<span v-if="index !== module.topicId.length - 1">, </span>
                          </span>
                        </template>
                        <template v-else>N/A</template>
                      </div>
                    </div>

                    <!-- Chapter -->
                    <div v-else-if="module.module_type === 'chapter'" class="mt-1 ml-2">
                      <div><strong>Chapter Title:</strong> {{ module.chapter_no || 'N/A' }}</div>
                      <div><strong>Description:</strong> {{ module.description || 'N/A' }}</div>
                    </div>
                  </b-td>

                    <b-td v-if="removeButtons == true">
                      <b-form-checkbox 
                        v-model="module.requiredSubscription"
                        switch
                        size="lg"
                        @change="statusChangeRequiredSubscription(module)"
                      >
                        <span class="sr-only">{{ module.requiredSubscription ? 'Public' : 'Private' }}</span>
                      </b-form-checkbox>
                    </b-td>

                    <b-td v-if="removeButtons == true">
                      <b-form-checkbox 
                        v-model="module.AllowGems"
                        switch
                        size="lg"
                        @change="statusChangeAllowGems(module)"
                      >
                        <span class="sr-only">{{ module.AllowGems ? 'Public' : 'Private' }}</span>
                      </b-form-checkbox>
                    </b-td>
                    <b-td v-if="removeButtons == true">
                  <div>
                    <div>
                      <b-form-checkbox v-model="module.androidAccess" v-on:change="statusChangeAccess(module, 'android')"
                        switch size="lg"></b-form-checkbox>
                    </div>
                  </div>
                </b-td>
                <b-td v-if="removeButtons == true">
                  <div >
                    <div>
                      <b-form-checkbox v-model="module.iosAccess" v-on:change="statusChangeAccess(module, 'ios')" switch
                        size="lg"></b-form-checkbox>
                    </div>
                  </div>
                </b-td>
                <b-td>
                  <div>
                    <div v-if="removeButtons == true">
                      <b-form-checkbox v-model="module.ipadAccess" v-on:change="statusChangeAccess(module, 'ipad')" switch
                        size="lg"></b-form-checkbox>
                    </div>
                  </div>
                </b-td>
                    <!-- <b-td>
                      <b-form-checkbox 
                        v-model="module.publicAccess"
                        switch
                        size="lg"
                        @change="statusChangePublicAccess(module)"
                      >
                        <span class="sr-only">{{ module.publicAccess ? 'Public' : 'Private' }}</span>
                      </b-form-checkbox>
                    </b-td> -->
                    <b-td v-if="removeButtons == true">
                      <b-dropdown variant="link" no-caret>
                        <template #button-content>
                          <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                        </template>
                        <b-dropdown-item @click="editModule(module)">
                          <feather-icon icon="EditIcon" />
                          <span class="align-middle ml-50">Edit</span>
                        </b-dropdown-item>
                        <b-dropdown-item @click="activeDeleteModule(module)">
                          <feather-icon icon="TrashIcon" />
                          <span class="align-middle ml-50">Delete</span>
                        </b-dropdown-item>
                      </b-dropdown>
                    </b-td>
              </b-tr>
            </b-tbody>
          </b-table>
        </div>
        </div>
      </b-card>
    </b-card>
  </div>
</template>



<script>
import {
  BCard, BRow, BCol, BFormInput, BButton,
  BTableSimple, BThead, BTr, BTh, BTbody, BTd,
  BFormCheckbox, BDropdown, BDropdownItem,
  BSidebar, BForm, BFormGroup,
} from 'bootstrap-vue'
import vSelect from "vue-select";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import AddNewChapter from "./app/list/users-list/AddNewChapter"; 
import axios from 'axios';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import draggable from "vuedraggable";
import ShowModule from "./Models/ShowModule.vue";

export default {
  components: {
    BCard, BRow, BCol, BFormInput, BButton,
    BTableSimple, BThead, BTr, BTh, BTbody, BTd,
    BFormCheckbox, BDropdown, BDropdownItem ,vSelect ,draggable,
    BSidebar, BForm, BFormGroup, AddNewChapter, ToastificationContent,ShowModule,
  },

  data() {
    return {
      showModuleModal: false,
      selectedModule: null,
      removeButtons:"",
      selectedSubjectId: '',
      isAddNewChapterSidebarActive: false,
      searchQuery: '',
      toastMessage: '',
      moduleToEdit: null,
      modules: [],
      subjects:[],
      topics:[],
      classId:"",
      record_filters: {
      class: "",
      subject: "",
      category: ""
    }
    }
  },

  computed: {
    filteredModules() {
      const query = this.searchQuery.trim().toLowerCase()
      return query.length > 0
        ? this.modules.filter(module =>
            module.module_name.toLowerCase().includes(query) ||
            module.module_no.toString().includes(query)
          )
        : this.modules
    }
  },
  mounted() {
    this.removeButtons = JSON.parse(localStorage.getItem("permission")).permission.some(permission => permission === "manage_modules");
  },

  methods: {
    capitalize(text) {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
  },
  openModuleModal(module) {
  this.selectedModule = module;
  this.showModuleModal = true;

},
handleModalClose() {
      this.showModuleModal = false;
      this.selectedModule = null;
    },
    getModuleTypeStyle(type) {
      const baseStyle = {
        color: '#fff',
        backgroundColor: '#6B7280', 
      };

      switch (type) {
        case 'chapter':
          baseStyle.backgroundColor = '#3B82F6';
          break;
        case 'evaluation':
          baseStyle.backgroundColor = '#10B981'; 
          break;
        case 'topic':
          baseStyle.backgroundColor = '#f6d75c'; 
          break;
          case 'comprehensive':
          baseStyle.backgroundColor = '#a903fc'; 
          break;
      }

      return baseStyle;
    },
    statusChangeAccess(module, accessType) {
      let status = '';
      if (accessType === 'ios') {
        status = module.iosAccess
      } else if (accessType === 'android') {
        status = module.androidAccess
      } else if (accessType === 'ipad') {
        status = module.ipadAccess
      }

      axios.post(
        `${process.env.VUE_APP_API_URL}/module/access/update`,
        {
          _id: module._id,
          accessType,
          status
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("_t")}`,
          }
        }
      )
      .then(response => {
          if (response.data.status) {
            this.toastMessage = response.data.message;
            this.showToast("success");
          }
        })
        .catch(error => {
          this.toastMessage = error.response.data.error || 'An error occurred';
          this.showToast("danger");
          this.gettabledata();
        });
    },

// async onDragEnd(evt) {
//   const movedModule = this.filteredModules[evt.oldIndex];
//   const afterModule = this.filteredModules[evt.newIndex];

//   if (!afterModule || !movedModule) return;

//   let newModuleNo = afterModule.module_no + 10;

//   while (this.modules.some(m => m.module_no === newModuleNo)) {
//     newModuleNo += 1;
//   }

//   try {
//     await axios.post(
//       process.env.VUE_APP_API_URL + '/modules/reorder',
//       { modules: [{ id: movedModule._id, module_no: newModuleNo }] },
//       {
//         headers: { Authorization: "Bearer " + localStorage.getItem("_t") },
//       }
//     );

//     this.toastMessage = "Module reordered successfully";
//     this.showToast("success");
//     this.gettabledata();
//   } catch (error) {
//     this.toastMessage = (error.response?.data?.error) || "Error occurred";
//     this.showToast("danger");
//     this.gettabledata();
//   }
// },

async onDragEnd(evt) {
  const movedModule = this.filteredModules[evt.oldIndex];
  const targetIndex = evt.newIndex;

  if (!movedModule || targetIndex === undefined) return;

  // Remove the module from old position
  this.filteredModules.splice(evt.oldIndex, 1);
  // Insert it into new position
  this.filteredModules.splice(targetIndex, 0, movedModule);

  // Reassign module_no to all in 10-10 gap
  const updatedModules = this.filteredModules.map((mod, index) => {
    return {
      id: mod._id,
      module_no: (index + 1) * 10,
    };
  });

  try {
    await axios.post(
      process.env.VUE_APP_API_URL + '/modules/reorder',
      { modules: updatedModules },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("_t") },
      }
    );

    this.toastMessage = "Modules reordered successfully";
    this.showToast("success");
    this.gettabledata();
  } catch (error) {
    this.toastMessage = error.response?.data?.error || "Error occurred";
    this.showToast("danger");
    this.gettabledata();
  }
},



    // async saveModuleOrder() {
    //   const reordered = this.filteredModules.map((m, i) => ({
    //     id: m._id,
    //     module_no: i + 1,
    //   }));

    //   try {
    //     const response = await axios.post(
    //       process.env.VUE_APP_API_URL + '/modules/reorder',
    //       { modules: reordered },
    //       {
    //         headers: { Authorization: "Bearer " + localStorage.getItem("_t") },
    //       }
    //     );

    //     if (response.data.status) {
    //       this.toastMessage = response.data.message;
    //       this.showToast("success");
    //       this.gettabledata();
    //     }
    //   } catch (error) {
    //     this.toastMessage = (error.response && error.response.data.error) || 'An error occurred';
    //     this.showToast("danger");
    //     this.gettabledata();
    //   }
    // },
    
    openAddChapterSidebar() {
      this.moduleToEdit = null;
      this.isAddNewChapterSidebarActive = true;
    },

    closeSidebar() {
      this.isAddNewChapterSidebarActive = false;
      this.moduleToEdit = null;
    },
    gettabledata() {
      axios.get(
        process.env.VUE_APP_API_URL + "/grade/subject/module?subject_id=" + this.selectedSubjectId,
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("_t") },
        }
      )
      .then(response => {
        this.modules = response.data.modules || [];
        this.subjects = response.data.subjects || [];
        this.topics = response.data.topics || [];
        this.classes = response.data.classes || [];
      })
      .catch(() => {
        this.toastMessage = "Failed to fetch modules";
        this.showToast("danger");
      });
    },

    statusChangeRequiredSubscription(subj) {
      axios
        .post(
          process.env.VUE_APP_API_URL + "/module/require-subscription/update",
          {
            _id: subj._id,
            requiredSubscription: subj.requiredSubscription
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("_t"),
            },
          }
        )
        .then(response => {
          if (response.data.status) {
            this.toastMessage = response.data.message;
            this.showToast("success");
          }
        })
        .catch(error => {
          this.toastMessage = error.response.data.error || 'An error occurred';
          this.showToast("danger");
          this.gettabledata();
        });
    },  

    statusChangeAllowGems(subj) {
      // console.log(subj)
      axios
        .post(
          process.env.VUE_APP_API_URL + "/module/allow_gems/update",
          {
            _id: subj._id,
            AllowGems: subj.AllowGems
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("_t"),
            },
          }
        )
        .then(response => {
          if (response.data.status) {
            this.toastMessage = response.data.message;
            this.showToast("success");
          }
        })
        .catch(error => {
          this.toastMessage = error.response.data.error || 'An error occurred';
          this.showToast("danger");
          this.gettabledata();
        });
    },  

    statusChangePublicAccess(subj) {
      axios
        .post(
          process.env.VUE_APP_API_URL + "/module/public-access/update",
          {
            _id: subj._id,
            publicAccess: subj.publicAccess
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("_t"),
            },
          }
        )
        .then(response => {
          if (response.data.status) {
            this.toastMessage = response.data.message;
            this.showToast("success");
          }
        })
        .catch(error => {
          this.toastMessage = error.response.data.error || 'An error occurred';
          this.showToast("danger");
          this.gettabledata();
        });
    },  
    
    createModule(module_data) {
      axios.post(
        process.env.VUE_APP_API_URL + "/grade/subject/module/create",
        module_data,
        { headers: { Authorization: "Bearer " + localStorage.getItem("_t") } }
      )
      .then(response => {
        if (response.data.message === "Module created successfully") {
          this.toastMessage = "Module created successfully";
          this.showToast("success");
          this.gettabledata();
        } else {
          this.toastMessage = "Failed to create module";
          this.showToast("danger");
        }
        this.closeSidebar();
      })
      .catch(() => {
        this.toastMessage = "Error creating module";
        this.showToast("danger");
      });
    },

    updateModule(module_data) {
      axios.put(
        `${process.env.VUE_APP_API_URL}/grade/subject/module/update/${module_data.id}`,
        module_data,
        { headers: { Authorization: "Bearer " + localStorage.getItem("_t") } }
      )
      .then(response => {
        if (response.data.message === "Module updated successfully") {
          this.toastMessage = "Module updated successfully";
          this.showToast("success");
          this.gettabledata();
        } else {
          this.toastMessage = response.data.message || "Failed to update module";
          this.showToast("danger");
        }
        this.closeSidebar();
      })
      .catch((error) => {
    if (error.response && error.response.data && error.response.data.message) {
      this.toastMessage = error.response.data.message;
    } else {
      this.toastMessage = "Error updating module";
    }
    this.showToast("danger");
  });
    },

    editModule(module) {
      console.log("parent module",module);
      const subject_ids = Array.isArray(module.subject_ids) && module.subject_ids.length > 0
        ? module.subject_ids
        : null;

      const topic_ids = Array.isArray(module.topic_ids) && module.topic_ids.length > 0
        ? module.topic_ids
        : null;
        // console.log("topic_ids",topic_ids);

      const selectedSubjects = subject_ids
        ? this.subjects.filter(s => subject_ids.includes(s._id))
        : [];


      // const selectedTopics = topic_ids
      //   ? this.topics.filter(t =>
      //       topic_ids.map(id => id.toString()).includes(t._id.toString())
      //     )
      //   : [];
 
      const selectedParentModules = Array.isArray(module.parentModuleId)
    ? module.parentModuleId
    :null;

      const selectedTopics = Array.isArray(module.topics_data) ? module.topics_data : [];

      // console.log("selectedTopics",selectedTopics);


      this.moduleToEdit = {
        module_no: module.module_no || module.order,
        module_name: module.module_name,
        module_type: module.module_type,
        estimated_time: module.estimated_time ,
        total_question: module.total_question,
        chapter_no: module.chapter_no ,
        description: module.description ,
        parent_module_id: selectedParentModules ,
        topic: module.topicId,
        subjects: selectedSubjects,
        topics: selectedTopics,
        id: module.id || module._id,
        title_test: module.title_test,
        total_marks:module.total_marks,
        weightages:module.weightages,
      };
      this.isAddNewChapterSidebarActive = true;
    },

    activeDeleteModule(module) {
      const moduleId = module._id;
      const moduleName = module.module_name;
      Swal.fire({
        title: "Are you sure?",
        text: `Delete Module "${moduleName}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(result => {
        if (result.isConfirmed) {
          axios.delete(
            `${process.env.VUE_APP_API_URL}/grade/subject/module/delete/${moduleId}`,
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("_t"),
              },
            }
          )
          .then(() => {
            this.toastMessage = "Module deleted successfully";
            this.showToast("success");
            this.gettabledata();
          })
          .catch(() => {
            this.toastMessage = "Failed to delete module";
            this.showToast("danger");
          });
        }
      });
    },

    showToast(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: this.toastMessage,
          variant,
        },
      });
    },
  },

  created() {
    this.selectedSubjectId = this.$route.params.subjectId;
    this.classId = this.$route.params.classId;
    this.gettabledata();
  }
}
</script>
<style>
.module-type-badge {
  display: inline-block;
  white-space: nowrap;
  font-size: 11px;
  line-height: 1.2;
  padding: 5px 10px;
  text-align: center;
  border-radius: 4px;
  min-width: 80px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

#custom-table-container {
  height: 100%;
  max-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

#custom-table-container .table-wrapper {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

#custom-table-container .table {
  margin-bottom: 0;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

#custom-table-container .scrollable-tbody {
  display: block;
  overflow-y: auto;
  max-height: calc(100vh - 250px); 
  scrollbar-width: thin;
}

#custom-table-container .scrollable-tbody::-webkit-scrollbar {
  width: 6px;
}

#custom-table-container .scrollable-tbody::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 10px;
}

#custom-table-container .scrollable-tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

#custom-table-container thead {
  display: table;
  width: 100%;
  table-layout: fixed;
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
}

#custom-table-container thead tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

/* Optional padding */
#custom-table-container .scrollable-tbody tr:first-child td {
  padding-top: 20px;
}

#custom-table-container .scrollable-tbody tr:last-child td {
  padding-bottom: 20px;
}

</style>
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>